<template>
  <div class="container-fluid bg-white">
    <div class="row">
      <div class="col-12 col-lg-6 px-4">
        <Upload :autocomplete-data="autocompleteData" />
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '../upload.vue'
import sidebarStore from '../sidebar_store'

export default {
  components: { Upload },
  computed: {
    autocompleteData() {
      return sidebarStore.uploadAutocompleteData
    }
  }
}
</script>
